function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import * as React from "react";

var _ref2 = /*#__PURE__*/React.createElement("linearGradient", {
  id: "a"
}, /*#__PURE__*/React.createElement("stop", {
  offset: 0.18,
  stopColor: "#0052cc"
}), /*#__PURE__*/React.createElement("stop", {
  offset: 1,
  stopColor: "#2684ff"
}));

var _ref3 = /*#__PURE__*/React.createElement("linearGradient", {
  id: "b",
  x1: "98.031%",
  x2: "58.888%",
  xlinkHref: "#a",
  y1: ".161%",
  y2: "40.766%"
});

var _ref4 = /*#__PURE__*/React.createElement("linearGradient", {
  id: "c",
  x1: "100.665%",
  x2: "55.402%",
  xlinkHref: "#a",
  y1: ".455%",
  y2: "44.727%"
});

var _ref5 = /*#__PURE__*/React.createElement("path", {
  d: "M244.658 0H121.707a55.502 55.502 0 0 0 55.502 55.502h22.649V77.37c.02 30.625 24.841 55.447 55.466 55.467V10.666C255.324 4.777 250.55 0 244.658 0z",
  fill: "#2684ff"
});

var _ref6 = /*#__PURE__*/React.createElement("path", {
  d: "M183.822 61.262H60.872c.019 30.625 24.84 55.447 55.466 55.467h22.649v21.938c.039 30.625 24.877 55.43 55.502 55.43V71.93c0-5.891-4.776-10.667-10.667-10.667z",
  fill: "url(#b)"
});

var _ref7 = /*#__PURE__*/React.createElement("path", {
  d: "M122.951 122.489H0c0 30.653 24.85 55.502 55.502 55.502h22.72v21.867c.02 30.597 24.798 55.408 55.396 55.466V133.156c0-5.891-4.776-10.667-10.667-10.667z",
  fill: "url(#c)"
});

function SvgJiraIcon(_ref, svgRef) {
  var title = _ref.title,
      titleId = _ref.titleId,
      props = _objectWithoutProperties(_ref, ["title", "titleId"]);

  return /*#__PURE__*/React.createElement("svg", _extends({
    height: 2500,
    preserveAspectRatio: "xMidYMid",
    width: 2500,
    xmlns: "http://www.w3.org/2000/svg",
    xmlnsXlink: "http://www.w3.org/1999/xlink",
    viewBox: "0 -30.632388516510233 255.324 285.95638851651023",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _ref2, _ref3, _ref4, _ref5, _ref6, _ref7);
}

var ForwardRef = /*#__PURE__*/React.forwardRef(SvgJiraIcon);
export default __webpack_public_path__ + "static/media/jira-icon.1b79d9d0.svg";
export { ForwardRef as ReactComponent };